import { CreateNewCourseForm } from 'components/ui/forms/course/types'
import {
  SynchronousCourse,
  SynchronousCourseDestroy,
} from 'models/course.model'

export const getSynchronousCourse = (
  values: CreateNewCourseForm
): SynchronousCourse | SynchronousCourseDestroy => {
  const {
    courseExternal,
    courseSynchronous,
    courseTypeSynchronous,
    courseSynchronousProperties,
  } = values

  const { max, min } = { ...courseSynchronousProperties }

  const synchronousCourse =
    courseExternal && courseTypeSynchronous && courseSynchronous
      ? {
          synchronousCourseType: courseTypeSynchronous,
          ...{
            minimumGrade: +(min || ''),
            maximumGrade: +(max || ''),
          },
          synchronousCourseSource: {
            value: courseExternal,
          },
        }
      : {
          _destroy: true,
        }
  return synchronousCourse
}
